import React from 'react';

import { Avatar, Button, Container, makeStyles, ThemeProvider, Typography } from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { colors, BaseMuiTheme } from '@style';
import { useAuth } from '@auth/AuthContext';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: colors.secondary
  },
  button: {
    marginTop: theme.spacing(4)
  }
}));

interface Props {
  name: string;
  redirectPath: string;
}

export const SignedOutPage: React.FC<Props> = ({ name, redirectPath }) => {
  const { signInRedirect } = useAuth();

  const classes = useStyles();

  return (
    <ThemeProvider theme={BaseMuiTheme}>
      <Container component='main' maxWidth='xs'>
        <div className={classes.paper}>
          <Avatar color='secondary'>
            <LockOutlinedIcon />
          </Avatar>
          <Typography variant='h1'>{name}</Typography>
          <Button
            className={classes.button}
            variant='contained'
            color='secondary'
            onClick={() => signInRedirect(redirectPath)}
          >
            Sign In
          </Button>
        </div>
      </Container>
    </ThemeProvider>
  );
};
